export const ProductName = "EBSWare";
